import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import resize8e34a2 from './resize'
import grayscaleEe90c0 from './grayscale'
import cropB72a3f from './crop'
import rotateBb1e5f from './rotate'
import compress63097f from './compress'
import convert22b4d6 from './convert'
import heicD21f7a from './heic'
import bulkResize3ee5ed from './bulk-resize'
import bulkCompressEd0339 from './bulk-compress'
/**
* @see \App\Http\Controllers\Tools\Image\EditImageController::editor
* @see Http/Controllers/Tools/Image/EditImageController.php:11
* @route '/{locale}/tools/image/editor'
*/
export const editor = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: editor.url(args, options),
    method: 'get',
})

editor.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/image/editor',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Image\EditImageController::editor
* @see Http/Controllers/Tools/Image/EditImageController.php:11
* @route '/{locale}/tools/image/editor'
*/
editor.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return editor.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Image\EditImageController::editor
* @see Http/Controllers/Tools/Image/EditImageController.php:11
* @route '/{locale}/tools/image/editor'
*/
editor.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: editor.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\EditImageController::editor
* @see Http/Controllers/Tools/Image/EditImageController.php:11
* @route '/{locale}/tools/image/editor'
*/
editor.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: editor.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Image\EditImageController::editor
* @see Http/Controllers/Tools/Image/EditImageController.php:11
* @route '/{locale}/tools/image/editor'
*/
const editorForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: editor.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\EditImageController::editor
* @see Http/Controllers/Tools/Image/EditImageController.php:11
* @route '/{locale}/tools/image/editor'
*/
editorForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: editor.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\EditImageController::editor
* @see Http/Controllers/Tools/Image/EditImageController.php:11
* @route '/{locale}/tools/image/editor'
*/
editorForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: editor.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

editor.form = editorForm

/**
* @see \App\Http\Controllers\Tools\Image\RemoveBackgroundController::removeBackground
* @see Http/Controllers/Tools/Image/RemoveBackgroundController.php:11
* @route '/{locale}/tools/image/remove-background'
*/
export const removeBackground = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: removeBackground.url(args, options),
    method: 'get',
})

removeBackground.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/image/remove-background',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Image\RemoveBackgroundController::removeBackground
* @see Http/Controllers/Tools/Image/RemoveBackgroundController.php:11
* @route '/{locale}/tools/image/remove-background'
*/
removeBackground.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return removeBackground.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Image\RemoveBackgroundController::removeBackground
* @see Http/Controllers/Tools/Image/RemoveBackgroundController.php:11
* @route '/{locale}/tools/image/remove-background'
*/
removeBackground.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: removeBackground.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\RemoveBackgroundController::removeBackground
* @see Http/Controllers/Tools/Image/RemoveBackgroundController.php:11
* @route '/{locale}/tools/image/remove-background'
*/
removeBackground.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: removeBackground.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Image\RemoveBackgroundController::removeBackground
* @see Http/Controllers/Tools/Image/RemoveBackgroundController.php:11
* @route '/{locale}/tools/image/remove-background'
*/
const removeBackgroundForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: removeBackground.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\RemoveBackgroundController::removeBackground
* @see Http/Controllers/Tools/Image/RemoveBackgroundController.php:11
* @route '/{locale}/tools/image/remove-background'
*/
removeBackgroundForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: removeBackground.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\RemoveBackgroundController::removeBackground
* @see Http/Controllers/Tools/Image/RemoveBackgroundController.php:11
* @route '/{locale}/tools/image/remove-background'
*/
removeBackgroundForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: removeBackground.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

removeBackground.form = removeBackgroundForm

/**
* @see \App\Http\Controllers\Tools\Image\ResizeImageController::resize
* @see Http/Controllers/Tools/Image/ResizeImageController.php:17
* @route '/{locale}/tools/image/resize'
*/
export const resize = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: resize.url(args, options),
    method: 'get',
})

resize.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/image/resize',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Image\ResizeImageController::resize
* @see Http/Controllers/Tools/Image/ResizeImageController.php:17
* @route '/{locale}/tools/image/resize'
*/
resize.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return resize.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Image\ResizeImageController::resize
* @see Http/Controllers/Tools/Image/ResizeImageController.php:17
* @route '/{locale}/tools/image/resize'
*/
resize.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: resize.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\ResizeImageController::resize
* @see Http/Controllers/Tools/Image/ResizeImageController.php:17
* @route '/{locale}/tools/image/resize'
*/
resize.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: resize.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Image\ResizeImageController::resize
* @see Http/Controllers/Tools/Image/ResizeImageController.php:17
* @route '/{locale}/tools/image/resize'
*/
const resizeForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: resize.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\ResizeImageController::resize
* @see Http/Controllers/Tools/Image/ResizeImageController.php:17
* @route '/{locale}/tools/image/resize'
*/
resizeForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: resize.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\ResizeImageController::resize
* @see Http/Controllers/Tools/Image/ResizeImageController.php:17
* @route '/{locale}/tools/image/resize'
*/
resizeForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: resize.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

resize.form = resizeForm

/**
* @see \App\Http\Controllers\Tools\Image\GrayscaleImageController::grayscale
* @see Http/Controllers/Tools/Image/GrayscaleImageController.php:17
* @route '/{locale}/tools/image/grayscale'
*/
export const grayscale = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: grayscale.url(args, options),
    method: 'get',
})

grayscale.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/image/grayscale',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Image\GrayscaleImageController::grayscale
* @see Http/Controllers/Tools/Image/GrayscaleImageController.php:17
* @route '/{locale}/tools/image/grayscale'
*/
grayscale.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return grayscale.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Image\GrayscaleImageController::grayscale
* @see Http/Controllers/Tools/Image/GrayscaleImageController.php:17
* @route '/{locale}/tools/image/grayscale'
*/
grayscale.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: grayscale.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\GrayscaleImageController::grayscale
* @see Http/Controllers/Tools/Image/GrayscaleImageController.php:17
* @route '/{locale}/tools/image/grayscale'
*/
grayscale.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: grayscale.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Image\GrayscaleImageController::grayscale
* @see Http/Controllers/Tools/Image/GrayscaleImageController.php:17
* @route '/{locale}/tools/image/grayscale'
*/
const grayscaleForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: grayscale.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\GrayscaleImageController::grayscale
* @see Http/Controllers/Tools/Image/GrayscaleImageController.php:17
* @route '/{locale}/tools/image/grayscale'
*/
grayscaleForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: grayscale.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\GrayscaleImageController::grayscale
* @see Http/Controllers/Tools/Image/GrayscaleImageController.php:17
* @route '/{locale}/tools/image/grayscale'
*/
grayscaleForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: grayscale.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

grayscale.form = grayscaleForm

/**
* @see \App\Http\Controllers\Tools\Image\CropImageController::crop
* @see Http/Controllers/Tools/Image/CropImageController.php:17
* @route '/{locale}/tools/image/crop'
*/
export const crop = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: crop.url(args, options),
    method: 'get',
})

crop.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/image/crop',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Image\CropImageController::crop
* @see Http/Controllers/Tools/Image/CropImageController.php:17
* @route '/{locale}/tools/image/crop'
*/
crop.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return crop.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Image\CropImageController::crop
* @see Http/Controllers/Tools/Image/CropImageController.php:17
* @route '/{locale}/tools/image/crop'
*/
crop.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: crop.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\CropImageController::crop
* @see Http/Controllers/Tools/Image/CropImageController.php:17
* @route '/{locale}/tools/image/crop'
*/
crop.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: crop.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Image\CropImageController::crop
* @see Http/Controllers/Tools/Image/CropImageController.php:17
* @route '/{locale}/tools/image/crop'
*/
const cropForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: crop.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\CropImageController::crop
* @see Http/Controllers/Tools/Image/CropImageController.php:17
* @route '/{locale}/tools/image/crop'
*/
cropForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: crop.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\CropImageController::crop
* @see Http/Controllers/Tools/Image/CropImageController.php:17
* @route '/{locale}/tools/image/crop'
*/
cropForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: crop.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

crop.form = cropForm

/**
* @see \App\Http\Controllers\Tools\Image\RotateImageController::rotate
* @see Http/Controllers/Tools/Image/RotateImageController.php:17
* @route '/{locale}/tools/image/rotate'
*/
export const rotate = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: rotate.url(args, options),
    method: 'get',
})

rotate.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/image/rotate',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Image\RotateImageController::rotate
* @see Http/Controllers/Tools/Image/RotateImageController.php:17
* @route '/{locale}/tools/image/rotate'
*/
rotate.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return rotate.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Image\RotateImageController::rotate
* @see Http/Controllers/Tools/Image/RotateImageController.php:17
* @route '/{locale}/tools/image/rotate'
*/
rotate.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: rotate.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\RotateImageController::rotate
* @see Http/Controllers/Tools/Image/RotateImageController.php:17
* @route '/{locale}/tools/image/rotate'
*/
rotate.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: rotate.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Image\RotateImageController::rotate
* @see Http/Controllers/Tools/Image/RotateImageController.php:17
* @route '/{locale}/tools/image/rotate'
*/
const rotateForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: rotate.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\RotateImageController::rotate
* @see Http/Controllers/Tools/Image/RotateImageController.php:17
* @route '/{locale}/tools/image/rotate'
*/
rotateForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: rotate.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\RotateImageController::rotate
* @see Http/Controllers/Tools/Image/RotateImageController.php:17
* @route '/{locale}/tools/image/rotate'
*/
rotateForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: rotate.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

rotate.form = rotateForm

/**
* @see \App\Http\Controllers\Tools\Image\CompressImageController::compress
* @see Http/Controllers/Tools/Image/CompressImageController.php:17
* @route '/{locale}/tools/image/compress'
*/
export const compress = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: compress.url(args, options),
    method: 'get',
})

compress.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/image/compress',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Image\CompressImageController::compress
* @see Http/Controllers/Tools/Image/CompressImageController.php:17
* @route '/{locale}/tools/image/compress'
*/
compress.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return compress.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Image\CompressImageController::compress
* @see Http/Controllers/Tools/Image/CompressImageController.php:17
* @route '/{locale}/tools/image/compress'
*/
compress.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: compress.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\CompressImageController::compress
* @see Http/Controllers/Tools/Image/CompressImageController.php:17
* @route '/{locale}/tools/image/compress'
*/
compress.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: compress.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Image\CompressImageController::compress
* @see Http/Controllers/Tools/Image/CompressImageController.php:17
* @route '/{locale}/tools/image/compress'
*/
const compressForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: compress.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\CompressImageController::compress
* @see Http/Controllers/Tools/Image/CompressImageController.php:17
* @route '/{locale}/tools/image/compress'
*/
compressForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: compress.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\CompressImageController::compress
* @see Http/Controllers/Tools/Image/CompressImageController.php:17
* @route '/{locale}/tools/image/compress'
*/
compressForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: compress.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

compress.form = compressForm

/**
* @see \App\Http\Controllers\Tools\Image\ConvertImageController::convert
* @see Http/Controllers/Tools/Image/ConvertImageController.php:17
* @route '/{locale}/tools/image/convert'
*/
export const convert = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: convert.url(args, options),
    method: 'get',
})

convert.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/image/convert',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Image\ConvertImageController::convert
* @see Http/Controllers/Tools/Image/ConvertImageController.php:17
* @route '/{locale}/tools/image/convert'
*/
convert.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return convert.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Image\ConvertImageController::convert
* @see Http/Controllers/Tools/Image/ConvertImageController.php:17
* @route '/{locale}/tools/image/convert'
*/
convert.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: convert.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\ConvertImageController::convert
* @see Http/Controllers/Tools/Image/ConvertImageController.php:17
* @route '/{locale}/tools/image/convert'
*/
convert.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: convert.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Image\ConvertImageController::convert
* @see Http/Controllers/Tools/Image/ConvertImageController.php:17
* @route '/{locale}/tools/image/convert'
*/
const convertForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: convert.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\ConvertImageController::convert
* @see Http/Controllers/Tools/Image/ConvertImageController.php:17
* @route '/{locale}/tools/image/convert'
*/
convertForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: convert.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\ConvertImageController::convert
* @see Http/Controllers/Tools/Image/ConvertImageController.php:17
* @route '/{locale}/tools/image/convert'
*/
convertForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: convert.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

convert.form = convertForm

/**
* @see \App\Http\Controllers\Tools\Image\HeicConvertController::heic
* @see Http/Controllers/Tools/Image/HeicConvertController.php:18
* @route '/{locale}/tools/image/heic'
*/
export const heic = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: heic.url(args, options),
    method: 'get',
})

heic.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/image/heic',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Image\HeicConvertController::heic
* @see Http/Controllers/Tools/Image/HeicConvertController.php:18
* @route '/{locale}/tools/image/heic'
*/
heic.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return heic.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Image\HeicConvertController::heic
* @see Http/Controllers/Tools/Image/HeicConvertController.php:18
* @route '/{locale}/tools/image/heic'
*/
heic.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: heic.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\HeicConvertController::heic
* @see Http/Controllers/Tools/Image/HeicConvertController.php:18
* @route '/{locale}/tools/image/heic'
*/
heic.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: heic.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Image\HeicConvertController::heic
* @see Http/Controllers/Tools/Image/HeicConvertController.php:18
* @route '/{locale}/tools/image/heic'
*/
const heicForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: heic.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\HeicConvertController::heic
* @see Http/Controllers/Tools/Image/HeicConvertController.php:18
* @route '/{locale}/tools/image/heic'
*/
heicForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: heic.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\HeicConvertController::heic
* @see Http/Controllers/Tools/Image/HeicConvertController.php:18
* @route '/{locale}/tools/image/heic'
*/
heicForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: heic.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

heic.form = heicForm

/**
* @see \App\Http\Controllers\Tools\Image\BulkResizeImageController::bulkResize
* @see Http/Controllers/Tools/Image/BulkResizeImageController.php:17
* @route '/{locale}/tools/image/bulk-resize'
*/
export const bulkResize = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: bulkResize.url(args, options),
    method: 'get',
})

bulkResize.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/image/bulk-resize',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Image\BulkResizeImageController::bulkResize
* @see Http/Controllers/Tools/Image/BulkResizeImageController.php:17
* @route '/{locale}/tools/image/bulk-resize'
*/
bulkResize.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return bulkResize.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Image\BulkResizeImageController::bulkResize
* @see Http/Controllers/Tools/Image/BulkResizeImageController.php:17
* @route '/{locale}/tools/image/bulk-resize'
*/
bulkResize.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: bulkResize.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\BulkResizeImageController::bulkResize
* @see Http/Controllers/Tools/Image/BulkResizeImageController.php:17
* @route '/{locale}/tools/image/bulk-resize'
*/
bulkResize.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: bulkResize.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Image\BulkResizeImageController::bulkResize
* @see Http/Controllers/Tools/Image/BulkResizeImageController.php:17
* @route '/{locale}/tools/image/bulk-resize'
*/
const bulkResizeForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: bulkResize.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\BulkResizeImageController::bulkResize
* @see Http/Controllers/Tools/Image/BulkResizeImageController.php:17
* @route '/{locale}/tools/image/bulk-resize'
*/
bulkResizeForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: bulkResize.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\BulkResizeImageController::bulkResize
* @see Http/Controllers/Tools/Image/BulkResizeImageController.php:17
* @route '/{locale}/tools/image/bulk-resize'
*/
bulkResizeForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: bulkResize.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

bulkResize.form = bulkResizeForm

/**
* @see \App\Http\Controllers\Tools\Image\BulkCompressImageController::bulkCompress
* @see Http/Controllers/Tools/Image/BulkCompressImageController.php:17
* @route '/{locale}/tools/image/bulk-compress'
*/
export const bulkCompress = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: bulkCompress.url(args, options),
    method: 'get',
})

bulkCompress.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/image/bulk-compress',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Image\BulkCompressImageController::bulkCompress
* @see Http/Controllers/Tools/Image/BulkCompressImageController.php:17
* @route '/{locale}/tools/image/bulk-compress'
*/
bulkCompress.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return bulkCompress.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Image\BulkCompressImageController::bulkCompress
* @see Http/Controllers/Tools/Image/BulkCompressImageController.php:17
* @route '/{locale}/tools/image/bulk-compress'
*/
bulkCompress.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: bulkCompress.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\BulkCompressImageController::bulkCompress
* @see Http/Controllers/Tools/Image/BulkCompressImageController.php:17
* @route '/{locale}/tools/image/bulk-compress'
*/
bulkCompress.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: bulkCompress.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Image\BulkCompressImageController::bulkCompress
* @see Http/Controllers/Tools/Image/BulkCompressImageController.php:17
* @route '/{locale}/tools/image/bulk-compress'
*/
const bulkCompressForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: bulkCompress.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\BulkCompressImageController::bulkCompress
* @see Http/Controllers/Tools/Image/BulkCompressImageController.php:17
* @route '/{locale}/tools/image/bulk-compress'
*/
bulkCompressForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: bulkCompress.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Image\BulkCompressImageController::bulkCompress
* @see Http/Controllers/Tools/Image/BulkCompressImageController.php:17
* @route '/{locale}/tools/image/bulk-compress'
*/
bulkCompressForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: bulkCompress.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

bulkCompress.form = bulkCompressForm

const image = {
    editor: Object.assign(editor, editor),
    removeBackground: Object.assign(removeBackground, removeBackground),
    resize: Object.assign(resize, resize8e34a2),
    grayscale: Object.assign(grayscale, grayscaleEe90c0),
    crop: Object.assign(crop, cropB72a3f),
    rotate: Object.assign(rotate, rotateBb1e5f),
    compress: Object.assign(compress, compress63097f),
    convert: Object.assign(convert, convert22b4d6),
    heic: Object.assign(heic, heicD21f7a),
    bulkResize: Object.assign(bulkResize, bulkResize3ee5ed),
    bulkCompress: Object.assign(bulkCompress, bulkCompressEd0339),
}

export default image